import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiKey } from './api-key.model';

@Injectable({
  providedIn: 'root'
})
export class ApiKeyService {
  constructor(private http: HttpClient) {}

  public get(): Observable<ApiKey> {
    return this.http.get<ApiKey>('/users/api-key');
  }

  public generate(): Observable<ApiKey> {
    return this.http.post<ApiKey>('/users/api-key', {});
  }

  public revoke(): Observable<ApiKey> {
    return this.http.delete<ApiKey>('/users/api-key');
  }
}
